import { render, staticRenderFns } from "./BusinessContactCompanyCreate.vue?vue&type=template&id=4168656c"
import script from "./BusinessContactCompanyCreate.vue?vue&type=script&lang=js"
export * from "./BusinessContactCompanyCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports